var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReimbursementListTemplate',{attrs:{"status":3,"tableList":['projectTitle', 'amount', 'filename', 'method', 'completeTime']}})}
var staticRenderFns = []

export { render, staticRenderFns }